// import { faFlowerTulip } from "@jewlr/pro-light-svg-icons/faFlowerTulip"
// import { faGift } from "@jewlr/pro-light-svg-icons/faGift"
import { faTruckFast } from "@jewlr/sharp-light-svg-icons/faTruckFast"
// import { faBoxHeart } from "@jewlr/pro-regular-svg-icons/faBoxHeart"
import PropTypes from "prop-types"

import FontAwesomeIcon from "components/ui/font-awesome-icon"
import {
  IS_PORTAL,
  jewlr_t,
  IS_GE_CHECKOUT,
  IS_UK,
  IS_AU,
} from "helpers/application"
import { cn } from "styles/utils"

const ShipMethod = ({ className = "", ...props }) => (
  <p className={cn("text-14 font-semibold text-black", className)} {...props} />
)

ShipMethod.propTypes = {
  className: PropTypes.string,
}

const LineItemShipping = ({ item }) => {
  // const forHer = item.product_gender === "female"
  const is_ge_checkout = IS_GE_CHECKOUT()
  const is_uk_or_au = IS_AU() || IS_UK()

  return (
    <div className="text-14 leading-18 desktop:mt-24 my-16">
      {item.holiday_availability && (
        <div className="tablet:flex text-sale-pink mb-8 hidden items-center">
          <FontAwesomeIcon className="mr-4" icon={faTruckFast} />
          <p className="text-16 font-semibold">
            Arrives Before{" "}
            {sl.config.guaranteed_holiday_alias || sl.config.guaranteed_holiday}
          </p>
        </div>
      )}
      {(!is_ge_checkout || is_uk_or_au) &&
      item.delivery_dates &&
      item.delivery_dates.length > 0 ? (
        item.delivery_dates.map((d) => (
          <ShipMethod
            data-cy={`itemShipping-${d.type}`}
            key={`itemShipping-${d.type}`}
          >
            <span>{d.type}</span>{" "}
            {!d.date_range?.length > 0 && (
              <span className="text-primary">{d.date}</span>
            )}
            {d.date_range?.length > 0 && (
              <>
                <span className="text-primary">{d.date_range[0]}</span> to{" "}
                <span className="text-primary">{d.date_range[1]}</span>
              </>
            )}
          </ShipMethod>
        ))
      ) : item.delivery_date_range ? (
        <ShipMethod>
          {IS_PORTAL() ? "Standard" : "Free"} {jewlr_t("terms.Shipping")}{" "}
          <span className="text-primary">
            {item.delivery_date_range[0]}-{item.delivery_date_range[1]}
          </span>
        </ShipMethod>
      ) : (
        <ShipMethod>
          Ships by <span className="text-primary">{item.est_ship_date}</span>
        </ShipMethod>
      )}
    </div>
  )
}

LineItemShipping.propTypes = {
  item: PropTypes.object,
}

export default LineItemShipping
